import APIClient from '@/shared/http/clients/api'

const resourceName = 'VistoriaChecklistSupervisao'
const APIBusinessCommon = process.env.APIBaseURLBusinessCommon

const GetByVistoriaId = (id, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/GetByVistoria/${id}`, data, config)

const VistoriaChecklistSupervisaoInconformidadeRepository = {
  GetByVistoriaId
}
export default VistoriaChecklistSupervisaoInconformidadeRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/checklistsurveychecklistsurvey.js